import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Button, Stack, Typography } from "@mui/material";
import { FilterButton, LoadingState, ProjectHeader } from "../../components";
import { RNSearchBar } from "./il-search";
import { InfluentialLeadersList } from "./il-list";
import { useStore } from "../../helpers";
import { AddInfluentialLeader } from "./add-influential-leader";
import { defaultIlFilters, defaultILValues } from "./il-types";
import { ILFilters } from "./il-filters";
import { useGetFullProject } from "../../custom-hooks";
import { ILBCrumbs } from "./il-bread-crumbs";
import PageShell from "../../layouts/PageShell";

const InfluentialLeadersHome = observer((props: any) => {
  const rootStore = useStore();
  const { influentialLeadersStore } = rootStore;
  const { isLoading } = useGetFullProject();

  useEffect(() => {
    //TODO: reset the query key in store, when this component unmounts.
    return () => {
      influentialLeadersStore.updateIlStoreProperty("searchQuery", "");
      influentialLeadersStore.updateIlStoreProperty(
        "activeInfluentialLeader",
        defaultILValues,
      );
      influentialLeadersStore.updateIlStoreProperty(
        "ilFilters",
        defaultIlFilters,
      );
      influentialLeadersStore.updateIlStoreProperty("offset", 1);
    };
  }, []);

  const hasActiveFilters = Object.values(
    influentialLeadersStore.ilFilters || {}
  ).some((val: any) =>
    Array.isArray(val) ? val.length > 0 : false
  );


  if (isLoading) return <LoadingState />;

  const Actions = (
    <Stack
      direction={"row"}
      gap={2}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <RNSearchBar
        onSearch={(query) => {
          influentialLeadersStore.updateIlStoreProperty(
            "searchQuery",
            query,
          );
        }}
      />

      <Stack direction="row" gap={1}>
        <FilterButton
          filterOnClickHandler={() =>
            influentialLeadersStore.updateIlStoreProperty(
              "ilFiltersModal",
              true,
            )
          }
        />

        {hasActiveFilters && (
          <Button
            color="warning"
            variant="outlined"
            onClick={() =>
              influentialLeadersStore.updateIlStoreProperty(
                "ilFilters",
                defaultIlFilters
              )
            }
          >
            Clear Filters
          </Button>

        )}
      </Stack>

      <Button
        endIcon={<i className={"fas fa-circle-plus"} />}
        variant={"contained"}
        onClick={() => {
          rootStore.influentialLeadersStore.updateIlStoreProperty(
            "addNewILModal",
            true,
          );
        }}
      >
        Add New
      </Button>
    </Stack>
  );



  return (
    <>
      <PageShell title="Influential Leaders" headerActions={Actions} breadcrumbs={<ILBCrumbs />}>
        <Stack className={"py-5 overflow-x-hidden"}>
          <ILFilters />
          <InfluentialLeadersList />
          <AddInfluentialLeader />
        </Stack>
      </PageShell>
    </>
  );
});

export default InfluentialLeadersHome;
